import PropTypes from "prop-types";
import { useEffect } from "react";
import { connect } from "react-redux";

import actions from "@/actions";

import Button from "../base/Button";

const renderIcon = (color) => (
    <svg width="22px" height="25px" viewBox="0 0 22 25" version="1.1">
        <title>align-right</title>
        <desc>Created with Sketch.</desc>
        <defs />
        <g
            id="Lightsmap-2.0"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
            strokeLinecap="square"
        >
            <g
                id="Select-Manual"
                transform="translate(-86.000000, -71.000000)"
                stroke={color}
            >
                <g id="toolbar" transform="translate(0.000000, 60.000000)">
                    <g
                        id="Group-12"
                        transform="translate(67.400000, 11.500000)"
                    >
                        <g
                            id="align-right"
                            transform="translate(19.000000, 0.000000)"
                        >
                            <path
                                d="M20.2758621,0.413793103 L20.2758621,23.5862069"
                                id="Shape"
                            />
                            <rect
                                id="Rectangle-path"
                                x="0.413793103"
                                y="3.72413793"
                                width="14.8965517"
                                height="5.79310345"
                            />
                            <rect
                                id="Rectangle-path"
                                x="7.86206897"
                                y="14.4827586"
                                width="7.44827586"
                                height="5.79310345"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

const AlignButton = (props) => {
    const { selectedTool, disabled, onSelectTool, ...buttonProps } = props;

    useEffect(() => {
        if (selectedTool && selectedTool.name === "align" && disabled) {
            onSelectTool(false);
        }
    }, [selectedTool, disabled, onSelectTool]);

    return (
        <Button {...buttonProps} disabled={disabled} renderIcon={renderIcon} />
    );
};

AlignButton.propTypes = {
    selectedTool: PropTypes.shape({
        name: PropTypes.string,
    }),
    disabled: PropTypes.bool,
    onSelectTool: PropTypes.func,
};

const mapStateToProps = ({ map }) => ({
    selectedTool: map.general.selectedTool,
    disabled: map.general.selectedLights.length <= 1,
});
const mapDispatchToProps = {
    onSelectTool: actions.map.general.selectTool,
};

export default connect(mapStateToProps, mapDispatchToProps)(AlignButton);
